import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceRolesKey } from '../../utils/keys';
export const useSpaceRoles = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const spaceRolesKey = getSpaceRolesKey(variables);
    return useQuery(spaceRolesKey, () => client.spaceRoles.list(variables, fields), useQueryOptions);
};
//# sourceMappingURL=useSpaceRoles.js.map